module.exports = "<div class=\"w1000 ma clearfix\">\n  <ul class=\"menu\">\n    <li class=\"menu-item\" *ngFor=\"let link of linksMap | allow: allowLinks\">\n      <a routerLink=\"{{link.link}}\" *ngIf=\"!link.external\">{{link.title}}</a>\n      <a [href]=\"link.link\" target=\"_self\" *ngIf=\"link.external\">{{link.title}}</a>\n    </li>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/core/menu/menu.component.html
// module id = UoxW
// module chunks = 6